import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTelegram, getStartParam } from 'lib/telegram';

// Applied-once latch shared across mounts. The authenticated shells remount
// within a single page load (Main flips between phone/desktop branches at the
// 768px breakpoint; CandidatePortal unmounts for the chromeless take-test
// routes and remounts on return), and the deep link must not re-fire and yank
// the user back to /join mid-session. A new Telegram open is a new page load,
// so a fresh deep link is never suppressed.
let handledThisLoad = false;

/** Forwards Telegram's `start_param` to /join/:code once per page load. Inert outside Telegram. */
export const TelegramStartParamHandler: React.FC = () => {
  const navigate = useNavigate();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current || handledThisLoad) return;
    fired.current = true;
    if (!isTelegram()) return;
    try {
      const param = getStartParam();
      if (!param) return;
      handledThisLoad = true;
      navigate(`/join/${encodeURIComponent(param)}`);
    } catch {
      // Best-effort: a deep link must never break the shell.
    }
    // Fire exactly once on mount; the latch owns re-entry.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default TelegramStartParamHandler;
